import React from 'react';
import { useNavigate } from 'react-router-dom';
import { platformInfo } from '../../config/landingData';
import { PATH_SEGMENTS, route } from '../../config/paths';
import './HeroSection.css';

const HeroSection: React.FC = () => {
  const navigate = useNavigate();
  const { hero, heroHighlight, subtext, industryHint } = platformInfo;

  const titleParts = heroHighlight && hero.includes(heroHighlight)
    ? (() => {
        const i = hero.indexOf(heroHighlight);
        return {
          before: hero.slice(0, i),
          highlight: heroHighlight,
          after: hero.slice(i + heroHighlight.length),
        };
      })()
    : { before: hero, highlight: '', after: '' };

  return (
    <section className="hero-section">
      <div className="hero-atmosphere" aria-hidden="true" />
      <div className="hero-content">
        <div className="hero-text">
          <p className="hero-brand-mark">Vhearu</p>
          <h1 className="hero-title">
            {titleParts.before}
            {titleParts.highlight ? (
              <span className="hero-highlight">{titleParts.highlight}</span>
            ) : null}
            {titleParts.after}
          </h1>
          <p className="hero-subtitle">{subtext}</p>
          <div className="hero-actions">
            <button
              type="button"
              className="hero-cta-primary"
              onClick={() => navigate(route(PATH_SEGMENTS.LIVE_DEMO))}
            >
              <span className="hero-cta-mic" aria-hidden="true" />
              Try live demo
            </button>
            <a className="hero-cta-secondary" href="#products">
              Explore products
            </a>
          </div>
          <p className="hero-industry-hint">{industryHint}</p>
        </div>

        <div className="hero-visual" aria-hidden="true">
          <div className="conversation-stage">
            <div className="stage-glow" />
            <div className="stage-orb">
              <div className="stage-mic" />
              <div className="stage-rings">
                <span />
                <span />
                <span />
              </div>
            </div>
            <div className="stage-waveform">
              {Array.from({ length: 16 }).map((_, i) => (
                <span key={i} style={{ animationDelay: `${i * 0.08}s` }} />
              ))}
            </div>
            <div className="stage-status">
              <span className="stage-status-dot" />
              Agent listening
            </div>
            <div className="stage-bubbles">
              <div className="stage-bubble stage-bubble-agent">
                Hi — I can help with your request. What do you need today?
              </div>
              <div className="stage-bubble stage-bubble-user">I’d like to…</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
